import * as types from './types';

const initialState = {
  isUpgradeModalOpen: false,
  isAutoApplyModalOpen: false,
  isApplicationModalOpen: false,
  isCoverLetterModalOpen: false,
  isImportJobModalOpen: false,
  isResumeEditorModalOpen: false,
  modalParams: {}
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.SET_MODAL_STATE:
      return {
        ...state,
        ...payload,
  
      };
  
    default:
      return state;
  }
}
